'use strict';

var React = require('react');
var Shape = require('./Shape.jsx');
var Icon = require('./Icon.jsx');

/**
 * 头像
 */
var AvatarEx = React.createClass({
  render: function () {
    var shapeProps = this.props.children[0].props;
    var iconProps = this.props.children[1].props;
    var iconStyle = {
      width: iconProps.w,
      height: iconProps.h,
      marginLeft: iconProps.x,
      marginTop: iconProps.y - 1,
      position: 'absolute'
    };
    var icon = iconProps.icon;
    if (icon.iconCode === '62168' && icon.iconFontName === 'jdIonicons') {
      iconStyle.width = Math.round(iconStyle.width * 9 / 7);
      iconStyle.height = Math.round(iconStyle.height * 9 / 7);
      iconStyle.marginLeft = Math.round((this.props.w - iconStyle.width) / 2);
      iconStyle.marginTop = this.props.h - Math.round(iconStyle.height * 8 / 9) - shapeProps.thickness + 1;
    }
    return (
      <div>
        <Shape {...shapeProps}
               key={this.props.children[0].key}></Shape>
        <div style={iconStyle}>
          <Icon {...iconProps}
                w={iconStyle.width}
                h={iconStyle.height}
                key={this.props.children[1].key}></Icon>
        </div>
      </div>
    );
  }
});

module.exports = AvatarEx;



// WEBPACK FOOTER //
// ./src/views/Components/AvatarEx.jsx